<template>
  <div></div>
</template>


<script>
export default {
  name: "TianDingCodeComponent",
  data() {
    return {
      user: null,
      code: "",
      state: "",
      router: ""
    };
  },
  mounted() {
    if (this.$route.query.code !== undefined) {
      this.code = this.$route.query.code;
      this.local$.removeItem("tdCode");
      this.local$.setItem("tdCode", this.code);
    }

    location.href = `/tdLogin`;
  }
};
</script>



// WEBPACK FOOTER //
// src/views/others/code.vue